import React from 'react'
import useCustomer from '../../../context/CustomerContext'
import FreeCourseList from './FreeCourseList'

function FreeCourse({ sectionRef }) {
  const { customer } = useCustomer()

  if (!customer?.tags?.includes('no_delete_L1_course_submitted')) return <div ref={sectionRef} />

  return (
    <section ref={sectionRef} className="outer margin-160">
      <div className="inner">
        <FreeCourseList />
      </div>
    </section>
  )
}

export default FreeCourse
